export default __webpack_public_path__ + "static/media/file-ppt.77813742.svg";